module.exports = __webpack_public_path__ + "9a8f18cefb1a672dbdd8fab755145c48.svg";